import { getBasePath } from '../../../utils/miscellaneous-utils'
import {
    SMALL_MOBILE_IMAGE_RESIZE_WIDTH,
    MEDIUM_MOBILE_IMAGE_RESIZE_WIDTH,
    TABLET_IMAGE_RESIZE_WIDTH,
    DESKTOP_IMAGE_RESIZE_WIDTH,
    LARGE_DESKTOP_IMAGE_RESIZE_WIDTH,
} from '../../../common/image-widths'
import type { BackgroundImages } from './styles'

const HOME_HERO_IMAGE_PATH = '/assets/images/hero/home-hero-desktop.jpg'
const HERO_IMAGE_PATH = '/assets/images/hero/home-hero-mobile.jpg'
const DEFAULT_REGION_IMAGE_PATH = '/assets/images/hero/default.jpg'
const TOPIC_HERO_IMAGE_PATH = '/assets/images/hero/urlaub.jpg'

/** Background images for home page hero section - used for both CSS and preloading */
export const HOME_BACKGROUND_IMAGES: BackgroundImages = {
    smallMobile: getBasePath(`${HERO_IMAGE_PATH}?imwidth=${SMALL_MOBILE_IMAGE_RESIZE_WIDTH}`),
    mobile: getBasePath(`${HERO_IMAGE_PATH}?imwidth=${MEDIUM_MOBILE_IMAGE_RESIZE_WIDTH}`),
    tablet: getBasePath(`${HOME_HERO_IMAGE_PATH}?imwidth=${TABLET_IMAGE_RESIZE_WIDTH}`),
    desktop: getBasePath(`${HOME_HERO_IMAGE_PATH}?imwidth=${DESKTOP_IMAGE_RESIZE_WIDTH}`),
    wideScreen: getBasePath(`${HOME_HERO_IMAGE_PATH}?imwidth=${LARGE_DESKTOP_IMAGE_RESIZE_WIDTH}`),
}

/** Background images for region page hero section - used for both CSS and preloading */
export const DEFAULT_REGION_BACKGROUND_IMAGES: BackgroundImages = {
    smallMobile: getBasePath(`${DEFAULT_REGION_IMAGE_PATH}?imwidth=${SMALL_MOBILE_IMAGE_RESIZE_WIDTH}`),
    mobile: getBasePath(`${DEFAULT_REGION_IMAGE_PATH}?imwidth=${MEDIUM_MOBILE_IMAGE_RESIZE_WIDTH}`),
    tablet: getBasePath(`${DEFAULT_REGION_IMAGE_PATH}?imwidth=${TABLET_IMAGE_RESIZE_WIDTH}`),
    desktop: getBasePath(`${DEFAULT_REGION_IMAGE_PATH}?imwidth=${DESKTOP_IMAGE_RESIZE_WIDTH}`),
    wideScreen: getBasePath(`${DEFAULT_REGION_IMAGE_PATH}?imwidth=${LARGE_DESKTOP_IMAGE_RESIZE_WIDTH}`),
}

/* Background imagess for topic landing page hero section */
export const TOPIC_BACKGROUND_IMAGES: BackgroundImages = {
    smallMobile: getBasePath(`${TOPIC_HERO_IMAGE_PATH}?imwidth=${SMALL_MOBILE_IMAGE_RESIZE_WIDTH}`),
    mobile: getBasePath(`${TOPIC_HERO_IMAGE_PATH}?imwidth=${MEDIUM_MOBILE_IMAGE_RESIZE_WIDTH}`),
    tablet: getBasePath(`${TOPIC_HERO_IMAGE_PATH}?imwidth=${TABLET_IMAGE_RESIZE_WIDTH}`),
    desktop: getBasePath(`${TOPIC_HERO_IMAGE_PATH}?imwidth=${DESKTOP_IMAGE_RESIZE_WIDTH}`),
    wideScreen: getBasePath(`${TOPIC_HERO_IMAGE_PATH}?imwidth=${LARGE_DESKTOP_IMAGE_RESIZE_WIDTH}`),
}
